var exports = {
  "E6": "ChannelEmbed.module__embed___bkhpU2",
  "vO": "ChannelEmbed.module__embedFull___bkhpU2",
  "UT": "ChannelEmbed.module__gridContainer___bkhpU2",
  "Vg": "ChannelEmbed.module__grid___bkhpU2",
  "$H": "ChannelEmbed.module__hasThumbnail___bkhpU2",
  "zE": "ChannelEmbed.module__embedContent___bkhpU2",
  "Cj": "ChannelEmbed.module__embedLink___bkhpU2",
  "zC": "ChannelEmbed.module__embedProvider___bkhpU2",
  "rN": "ChannelEmbed.module__embedAuthor___bkhpU2",
  "QQ": "ChannelEmbed.module__embedAuthorName___bkhpU2",
  "av": "ChannelEmbed.module__embedAuthorNameLink___bkhpU2",
  "SG": "ChannelEmbed.module__embedAuthorIcon___bkhpU2",
  "gt": "ChannelEmbed.module__embedTitle___bkhpU2",
  "cD": "ChannelEmbed.module__embedDescription___bkhpU2",
  "j0": "ChannelEmbed.module__embedFields___bkhpU2",
  "Me": "ChannelEmbed.module__embedField___bkhpU2",
  "$L": "ChannelEmbed.module__embedFieldName___bkhpU2",
  "VN": "ChannelEmbed.module__embedFieldValue___bkhpU2",
  "oy": "ChannelEmbed.module__embedFooterText___bkhpU2",
  "W$": "ChannelEmbed.module__embedMedia___bkhpU2",
  "ad": "ChannelEmbed.module__embedThumbnail___bkhpU2",
  "te": "ChannelEmbed.module__embedFooter___bkhpU2",
  "mG": "ChannelEmbed.module__embedFooterIcon___bkhpU2",
  "i8": "ChannelEmbed.module__embedFooterSeparator___bkhpU2",
  "PN": "ChannelEmbed.module__embedGifvContainer___bkhpU2",
  "kL": "ChannelEmbed.module__container___bkhpU2",
  "mQ": "ChannelEmbed.module__mediaFrame___bkhpU2",
  "Mc": "ChannelEmbed.module__suppressButton___bkhpU2",
  "wJ": "ChannelEmbed.module__mediaSuppressButton___bkhpU2",
  "Fk": "ChannelEmbed.module__blueskyMediaEngagement___bkhpU2",
  "Uf": "ChannelEmbed.module__blueskyGalleryMedia___bkhpU2",
  "$j": "ChannelEmbed.module__blueskyEngagement___bkhpU2",
  "Z": "ChannelEmbed.module__blueskyNestedEmbedContainer___bkhpU2",
  "mx": "ChannelEmbed.module__blueskyNestedEmbed___bkhpU2",
  "gp": "ChannelEmbed.module__blueskyNestedMediaEngagement___bkhpU2",
  "qP": "ChannelEmbed.module__blueskyEngagementItem___bkhpU2",
};

module.exports = exports;
